import { render, staticRenderFns } from "./resetBtn.vue?vue&type=template&id=003fc5a9&scoped=true&"
import script from "./resetBtn.vue?vue&type=script&lang=js&"
export * from "./resetBtn.vue?vue&type=script&lang=js&"
import style0 from "./resetBtn.vue?vue&type=style&index=0&id=003fc5a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003fc5a9",
  null
  
)

export default component.exports